import Flex from '@blocks/Flex'
import Info from '@blocks/Info'
import React from 'react'

export default function PastParticipationScore({ score }: Props) {
    return (
        <Flex justifyContent="flex-end"><Info label={`Score: ${score}`} /></Flex>
    )
}

interface Props {
    score: number
}